import {skipToken} from '@reduxjs/toolkit/query';
import {DataStatus} from 'platform/components';

import {useParams} from 'react-router-dom';

import {isNotNil} from 'ramda-adjunct';

import {useGetSalePresetSettingsV2Query} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {SalePresetForm} from './components/SalePresetForm';

export function SalePresetDetail() {
  const {id} = useParams();

  const {data, isError, isFetching} = useGetSalePresetSettingsV2Query(
    isNotNil(id) ? {salePresetId: id} : skipToken,
    {refetchOnMountOrArgChange: true}
  );

  return (
    <SettingsTemplate
      header={{
        title: data?.name
          ? i18n.t('page.salesSettings.labels.salePresetDetailName', {name: data?.name})
          : i18n.t('page.salesSettings.salePreset.newConfiguration'),
        breadcrumbs: [
          {
            label: i18n.t('page.salesSettings.labels.advertising'),
            href: settingsRoutes.advertising,
          },
          {
            label: i18n.t('page.salesSettings.labels.salePreset'),
            href: settingsRoutes.salePreset,
          },
        ],
      }}
      data-testid="settings-salePresetDetail"
      description={i18n.t('page.salesSettings.salePreset.descriptionDetail')}
    >
      <DataStatus isLoading={isFetching} isError={isError}>
        <SalePresetForm settings={data} />
      </DataStatus>
    </SettingsTemplate>
  );
}
